import { Text } from 'ui'
import { Container } from './styles'

import { ReactComponent as ClockSVG } from 'assets/icons/clock.svg'
import { ReactComponent as PeopleSVG } from 'assets/icons/people.svg'
import { ReactComponent as LightSVG } from 'assets/icons/light.svg'
import { ReactComponent as SettingsSVG } from 'assets/icons/settings.svg'
import { ReactComponent as PresentationSVG } from 'assets/icons/presentation.svg'
import { ReactComponent as LockSVG } from 'assets/icons/lock.svg'
import i18n from 'i18n'

const MESSAGES = [
  {
    icon: ClockSVG,
    text: i18n.t('globalMicroseries'),
  }, {
    icon: PeopleSVG,
    text: i18n.t('independentCreators'),
  }, {
    icon: LightSVG,
    text: i18n.t('diverseContents'),
  }, {
    icon: SettingsSVG,
    text: i18n.t('weAdviceYou'),
  }, {
    icon: PresentationSVG,
    text: i18n.t('canExpandYourReach'),
  }, {
    icon: LockSVG,
    text: i18n.t('yourContentYourRules'),
  },
]

const Benefits = () => (
  <Container>
    {MESSAGES.map(msg => (
      <div key={msg.text}>
        <Text color='highlight' as='span'>
          <msg.icon transform='translate(0, 2)' />
        </Text>
        {' '}
        <Text as='span'>
          {msg.text}
        </Text>
      </div>
    ))}
  </Container>
)

export default Benefits